import { MatTableModule } from '@angular/material/table';

import {
  Component,
  inject,
  Injectable,
  OnChanges,
  signal,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CardComponent } from '../../../shared/components/card/card.component';
import { TituloInterface } from '../../../models/titulo.model';
import { TituloService } from '../../../core/titulo.service';
import {
  COMPETENCIAS_ACTIONS,
  COMPETENCIAS_COLUMN_NAMES,
  COMPETENCIAS_FIELDS_CONFIG,
} from '../../../constants/competencias.constants';
import {
  DEFAULT_PAGINATE_OPTIONS_LIST,
  PaginateData,
  PaginateOptions,
} from '../../../utils/paginate.utils';
import { CompetenciaInterface } from '../../../models/competencia.model';
import { CompetenciasService } from '../../../core/competencia.service';
import { BaseSelectService } from '../../../core/BaseSelect.service';
import { Table } from '../../../shared/components/table/table.component';
import { Modal } from '../../../shared/components/modal/modal.component';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { InputComponent } from '../../../shared/components/input/input.component';
import { Button } from '../../../shared/components/button/button.component';
import {
  TITULOS_ACTIONS_CONSULTA,
  TITULOS_COLUMN_NAMES,
} from '../../../constants/titulos.constants';
import { TituloUsuarioService } from '../../../core/tituloUsuario.service';
import { TituloUsuarioInterface } from '../../../models/titulo-usuario.model';
import { TITULOS_USUARIO_COLUMN_NAMES } from '../../../constants/titulos-usuario.constants';
@Injectable({
  providedIn: 'root',
})
@Component({
  selector: 'app-por-dni',
  imports: [
    CommonModule,
    CardComponent,
    InputComponent,
    Table,
    Titledescription,
    Button,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTableModule,
  ],
  templateUrl: './por-dni.component.html',
  styleUrl: './por-dni.component.scss',
})
export class PorDniComponent {
  modalService = inject(Modal);
  titulosByDniData!: PaginateData<TituloInterface>;
  titulosUsuarioByDniData!: PaginateData<TituloUsuarioInterface>;
  dataFetchCompetencias!: {
    nivel: number;
    nivelDescripcion: string;
    competencias: CompetenciaInterface[];
  }[];
  dataFetchCompetenciasByNivel: { [nivel: string]: CompetenciaInterface[] } = {};
  expandedNivel: number | null = null;
  constructor() {
    this.dataFetchCompetenciasByNivel = {};
  }
  toggleNivel(nivel: number) {
    this.expandedNivel = this.expandedNivel === nivel ? null : nivel;
  }

  isNivelExpanded(nivel: number) {
    return this.expandedNivel === nivel;
  }
  competenciaService = inject(CompetenciasService);
  tituloService = inject(TituloService);
  tituloUsuarioService = inject(TituloUsuarioService);
  dataTitulo!: TituloInterface;
  columnNamesCompetencias = COMPETENCIAS_COLUMN_NAMES;
  columnNamesTitulos = TITULOS_COLUMN_NAMES;
  fieldsAddCompetencias = COMPETENCIAS_FIELDS_CONFIG;
  actionsTitulos = TITULOS_ACTIONS_CONSULTA;
  columnNamesTitulosUsuario = TITULOS_USUARIO_COLUMN_NAMES;
  take: number = 100;
  skip: number = 0;
  totalItems!: number;
  titulo_id!: number;
  tituloSelected!: number;
  dataSelectTitulos: any[] = [];
  actions = COMPETENCIAS_ACTIONS;
  dni!: number;
  disableSearch = signal(true);
  isLoading: boolean = false;
  paginateData: PaginateOptions = { ...DEFAULT_PAGINATE_OPTIONS_LIST };
  defaultPaginateData = { ...DEFAULT_PAGINATE_OPTIONS_LIST };
  @ViewChild('tableCompetencias') tableCompetencias!: Table<CompetenciaInterface>;
  getTitulosMediaByDni = (data: PaginateOptions , ignoreCache?:boolean) => {
    return this.competenciaService.getByDni(data , this.dni, ignoreCache).subscribe((data) => {
      data.data = data.data.filter((item: any) => item !== null);
      this.titulosByDniData = data;
    });
  };
  getTitulosPortalByDni = (data: PaginateOptions , ignoreCache?:boolean) => {
      return this.tituloUsuarioService.getByDni(data , this.dni, ignoreCache).subscribe({
        next: (data: PaginateData<TituloUsuarioInterface>) => {
          data.data = [...data.data.filter((item: TituloUsuarioInterface | null): item is TituloUsuarioInterface => item !== null)];
          this.titulosUsuarioByDniData = data;
        },
        error: () => {
        }
      });
    }
  getCompetencias = (event: PaginateOptions) => {
    this.paginateData = event;

    return this.competenciaService
      .getCompetenciasAgrupadasByDni(this.paginateData, this.dni, this.titulo_id)
      .subscribe((data) => {
        this.isLoading = false;
        this.dataFetchCompetencias = Array.isArray(data.data) ? data.data : [];
        console.log('event', this.dataFetchCompetencias);
      });
  };
  onDniInput(value: number) {
    this.dni = value;
  }
  searchTitulos = (dniValueOrEvent?: number | Event) => {
    let dniValue = this.dni;
    if (typeof dniValueOrEvent === 'number') {
      dniValue = dniValueOrEvent;
    } else if (dniValueOrEvent && typeof dniValueOrEvent === 'object' && 'target' in dniValueOrEvent) {
      const input = dniValueOrEvent.target as HTMLInputElement;
      dniValue = Number(input.value);
    }
    this.dni = dniValue;
    this.getTitulosMediaByDni(this.defaultPaginateData, false);
    this.getTitulosPortalByDni(this.defaultPaginateData, false);
  };
  openModal(event: any) {
    this.dataFetchCompetencias = []; // Limpia las competencias anteriores
    this.isLoading = true;
    this.titulo_id = event.id;
    this.getCompetencias(this.paginateData);
    this.expandedNivel = null;
  }

  isLoadingPDF = signal(false);

  async downloadAllCompetenciasPDF() {
    this.isLoadingPDF.set(true);
    try {
      const jsPDF = await import('jspdf');
      const doc = new jsPDF.jsPDF();
      let titulos = this.titulosByDniData?.data || [];
      let y = 10;
      for (const titulo of titulos) {
        // Obtener competencias para cada título
        const competencias = await new Promise<any[]>((resolve) => {
          this.competenciaService
            .getByTitulo({ skip: 0, take: 100 }, titulo.id)
            .subscribe((data) => {
              resolve(data.data || []);
            });
        });
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(16);
        doc.text(`Título: ${titulo.descripcion || titulo.codigo || titulo.id}`, 10, y);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(11);
        y += 10;
        if (competencias.length === 0) {
          doc.text('  Sin competencias asociadas.', 10, y);
          y += 8;
        } else {
          competencias.forEach((comp: CompetenciaInterface) => {
            const row = `• ${comp.materia.descripcion || ''} - (${comp.nivel.descripcion || ''})`;
            doc.text(row, 18, y); // Sangría de 8 unidades
            y += 7;
            if (y > 270) {
              doc.addPage();
              y = 10;
            }
          });
        }
        y += 8;
        if (y > 270) {
          doc.addPage();
          y = 10;
        }
      }
      doc.save('competencias_por_titulo.pdf');
    } finally {
      this.isLoadingPDF.set(false);
    }
  }
  // Devuelve un array de agrupaciones para iterar fácilmente en la vista
  get competenciasPorNivelArray() {
    return Object.entries(this.dataFetchCompetenciasByNivel || {}).map(
      ([nivelId, competencias]) => ({
        nivelId,
        competencias,
      }),
    );
  }
}
